import {TaxAccountantConsultationForm} from "@/features/manage";
import {vars} from "@/shared/lib/theme.css";
import {Column} from "@/shared/ui";
import {createFileRoute} from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)/_layout/tax-accountant/")({
	component: TaxManageScreen
});

function TaxManageScreen() {
	return (
		<Column fullWidth style={{minHeight: "100vh", gap: vars.size[32], paddingBottom: 200}}>
			<TaxAccountantConsultationForm />
		</Column>
	);
}
